<template>
  <div class="sidebar">
    <el-menu
      :default-active="$route.path" class="el-menu-vertical-demo" unique-opened router :collapse="isCollapse">
      <template v-for="(item, index) in $store.state.tabList">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="index">
            <template slot="title">
              <i :class="item.icon"></i>
              {{ item.title }}
            </template>
            <el-menu-item
              v-for="(subItem,i) in item.subs"
              :key="i"
              :index="subItem.index"
            >{{ subItem.title }}</el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="index">
            <i :class="item.icon"></i>
            {{ item.title }}
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isCollapse: false
    }
  }
}
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  width: 55px;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow: auto;
}
.sidebar > ul {
  height: 100%;
}
</style>
